import pkg from '../../package.json';

export const version = pkg.version;

export const getEnv = () => import.meta.env.VITE_APP_ENV;

function getDefaultApiUrl(): string {
  if (typeof window !== 'undefined') {
    const { protocol, hostname } = window.location;
    return `${protocol}//${hostname}:6870`;
  }
  return 'http://localhost:6870';
}

function getDefaultSocketUrl(): string {
  if (typeof window !== 'undefined') {
    const { protocol, hostname } = window.location;
    const wsProtocol = protocol === 'https:' ? 'wss:' : 'ws:';
    return `${wsProtocol}//${hostname}:6871`;
  }
  return 'ws://localhost:6871';
}

export const apiUrl = import.meta.env.VITE_API_URL || getDefaultApiUrl();
export const isSocketUrlConfigured = Boolean(import.meta.env.VITE_SOCKET_URL);
export const socketUrl =
  import.meta.env.VITE_SOCKET_URL || getDefaultSocketUrl();

export const isDev = getEnv() === 'development';
export const isProd = getEnv() === 'production';
export const isPreview = getEnv() === 'preview';

export const gitBranch = import.meta.env.VERCEL_GIT_BRANCH;
export const gitCommitMessage = import.meta.env.VERCEL_GIT_COMMIT_MESSAGE;
